import { LoanApplicationComponent } from '@pylonlending/react-elements';
import { useState } from 'react';
import { Grid } from '@mui/material';

// Our Components
import Loader from 'components/Loader/';
import SelectClientViaAdvisor from 'components/ClientSearchViaAdvisor/SelectClientViaAdvisor';
import { PrimaryButton } from 'components/Button/Button';

// Our Hooks
import useGetClientPylonId from 'hooks/pylon/useGetClientPylonId';

function PylonLoanApplication() {
	const [selectedAdvisor, setSelectedAdvisor] = useState(null);
	const [selectedClient, setSelectedClient] = useState(null);
	const [selectedLoanApplication, setSelectedLoanApplication] = useState('');

	// Checks
	const hasSelectedAdvisorAndClient = !!selectedAdvisor && !!selectedClient;
	const isGetLoanIdReady =
		selectedAdvisor && selectedClient && selectedLoanApplication;

	const loanId = isGetLoanIdReady && selectedLoanApplication.split(' - ')[1];

	const { isLoading, isSuccess, data } = useGetClientPylonId(
		{
			clientId: selectedClient?.id,
			loanId: loanId ? loanId : null
		},
		hasSelectedAdvisorAndClient
	);

	return (
		<div>
			<SelectClientViaAdvisor
				selectedClient={selectedClient}
				setSelectedClient={setSelectedClient}
				selectedAdvisor={selectedAdvisor}
				setSelectedAdvisor={setSelectedAdvisor}
				selectedLoanApplication={selectedLoanApplication}
				setSelectedLoanApplication={setSelectedLoanApplication}
			>
				{isGetLoanIdReady && (
					<Grid item xs={12}>
						<PrimaryButton
							onClick={() => {
								setSelectedLoanApplication('');
							}}
						>
							Start new application
						</PrimaryButton>
					</Grid>
				)}
			</SelectClientViaAdvisor>
			<div>
				{isSuccess && (
					<LoanApplicationComponent
						key={loanId}
						loanId={loanId}
						authLeaseCallback={() => {
							const { resp: pylonAuth } = data;
							return pylonAuth;
						}}
					/>
				)}
			</div>
			{isLoading && <Loader />}
		</div>
	);
}

export default PylonLoanApplication;
